import styled from 'styled-components';
import { animated } from 'react-spring';

export const AnimatedContainer = styled(animated.div)`
	display: flex;
	width: 100%;
	will-change: opacity, transform;
`;
